<template>
  <div class="gallery">
    <carousel :perPage="1" :paginationEnabled="false" :centerMode="true">
      <slide v-for="pic in galleryImages" :key="pic._id">
        <img :src="getImage(pic._id)" />
      </slide>
    </carousel>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'Gallery',
  components: {
    Carousel,
    Slide
  },
  mounted () {
    this.$store.dispatch('images/getAll')
  },
  computed: {
    ...mapState({
      list: state => state.images.list
    }),
    galleryImages() {
      let array = []
      if  (this.list) {
        this.list.map(i => {
            if (i.tags.includes('gallery')) {
              array.push(i)
            }
          }
        )
      }
      return array
    }
  },
  methods: {
    getImage(id) {
      let path = ''
      this.list.map(i => {
        if (i._id === id) {
          path = i.source.path
        }
      })
      return path
    },
  }
}
</script>


<style lang="scss" scoped>
.gallery {
  padding: 50px;
}
.VueCarousel {
    margin: 0px auto;
    width: 100%;
    height: 480px;
    // max-width: 1280px;
    box-sizing: border-box;
    padding: 0 20px;
    overflow: hidden;
    div.gallery {
      padding-left: 15px;
      padding-right: 15px;
    }
    img {
      cursor: grab;
      object-fit: contain;
      pointer-events: none;
      width: 100%;
      max-height: 480px;
    }

  }

@media (max-width: 414px) {
  .gallery {
    padding: 10px;
  }
  .VueCarousel { 
    max-height: 100vw;
  }
}
</style>